var React = require('react');

function SingleDashboard (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"30","cy":"30","r":"30","fill":"#FFCC00","key":0}),React.createElement("path",{"d":"M42 37.5H18M42 42H18M18 33H42V18H18V33ZM30 22.5C28.344 22.5 27 23.8425 27 25.5C27 27.156 28.344 28.5 30 28.5C31.6575 28.5 33 27.156 33 25.5C33 23.8425 31.6575 22.5 30 22.5Z","stroke":"#121212","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

SingleDashboard.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = SingleDashboard;

SingleDashboard.default = SingleDashboard;
